import * as React from "react";
import { UserCtx } from '../context/UserContext';

const useUser = () => React.useContext(UserCtx);

export default useUser;